import React, { CSSProperties } from 'react';
import styles from './style.less';
import BigNumber from 'bignumber.js';
import { MinusOutlined } from '@ant-design/icons';

type Props = Partial<{
  value: string | number | BigNumber;
  className?: string;
  style?: CSSProperties;
  valueStyle?: CSSProperties;
  type?: 'primary' | 'secondary' | 'green';
  negative?: boolean;
  showSymbol?: boolean;
}>;

const Price: React.FC<Props> = ({
  value,
  type = 'primary',
  className = '',
  style = {},
  valueStyle = {},
  negative: specifiedNegative,
  showSymbol = true,
}: Props) => {
  if (value === undefined || value === null) {
    return null;
  }

  let negative = false;
  if (specifiedNegative === undefined) {
    if (value instanceof BigNumber) {
      negative = value.comparedTo(0) < 0;
    } else {
      negative = Number(value) < 0;
    }
  } else {
    negative = specifiedNegative;
  }

  return (
    <span
      className={`${className} ${styles.main} ${styles[type]} ${negative ? styles.negative : ''}`}
      style={style}>
      {negative && showSymbol && <MinusOutlined className={styles.symbol} />}
      {showSymbol && <span className={styles.tag}>&yen;</span>}
      <span className={styles.value} style={valueStyle}>
        {value instanceof BigNumber ? value.abs().toFixed(2) : Math.abs(+value)}
      </span>
    </span>
  );
};

export default Price;
